import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './NewsBanner.module.scss';
import { Image } from '../../components/Image';

interface Props {
  newsCenterTitle: string;
  newsCenterImg: string;
  categoryName?: string;
}
const NewsBanner: FC<Props> = (props) => {
  const { newsCenterTitle, newsCenterImg, categoryName } = props;
  const bannerBg = 'https://p0.meituan.net/smartvenus/b57807e9a752bf76b1d72714d409aa0f43379.png';
  const bannerStyleMo = {
    backgroundImage: `url(${bannerBg})`,
  };

  return (
    <section className={styles['news-banner-box']} style={bannerStyleMo}>
      <div className={styles['banner-wrap']}>
        <div className={classNames(styles['banner-title'], 'mt-font', { [styles['banner-title-xl']]: !categoryName })}>
          {categoryName ? `${newsCenterTitle}-${categoryName}` : newsCenterTitle}
        </div>
        <div className={styles['banner-img-box']}>
          <Image objectFit="cover" src={newsCenterImg} layout="fill" />
        </div>
      </div>
    </section>
  );
};
NewsBanner.defaultProps = {};

NewsBanner.displayName = 'NewsBanner';
export default NewsBanner;
